import { OrderStates, OrderStatus, PaymentType } from '../consts.js'
import moment from 'moment'
import cloneDeep from 'lodash.clonedeep'

export default function stateProcessor(order, catalog, client) {
  function updateItemInAssembledItems(itemUUID, orderItemUUID, sendUpdate = true) {
    let changed = false
    let existing = cloneDeep(order.assembledOrderItems[orderItemUUID])
    let assembledItem = order.items.assembleItem(itemUUID, orderItemUUID)
    let modifiersUnchanged = (JSON.stringify(assembledItem?.modifierGroups || []) === JSON.stringify(existing?.modifierGroups || []))
    if (assembledItem != null &&
      (
        (assembledItem?.totalPrice !== (existing?.totalPrice - existing?.serviceFeeNoDiscount))
        || (assembledItem?.takeAway !== existing?.takeAway)
        || (assembledItem?.selectedSizeUUID !== existing?.selectedSizeUUID)
        || (assembledItem?.state !== existing?.state)
        || (assembledItem?.notes !== existing?.notes)
        || (assembledItem?.payment?.count !== existing?.payment?.count)
        || (assembledItem?.servingID !== existing?.servingID)
        || (assembledItem?.quantity !== existing?.quantity)
        || (assembledItem?.count !== existing?.count)
        || (!modifiersUnchanged)
      )
    ) {
      //console.log('BEFORE : ', cloneDeep(assembledItem), cloneDeep(order.assembledOrderItems))
      order.assembledOrderItems[orderItemUUID] = cloneDeep(assembledItem)
      //console.log('AFTER? : ', cloneDeep(assembledItem), cloneDeep(order.assembledOrderItems))
      changed = true
      order.callbacks.callCallbacks(orderItemUUID, cloneDeep(assembledItem))
    }
    if (changed && sendUpdate) order.callbacks.callCallbacks('onOrderUpdated', order)
    return changed
  }

  function reBuildAssembledItems() {
    for (let item of order.order.items) {
      let changed = updateItemInAssembledItems(item.itemUUID, item.orderItemUUID, false)
      if (changed) {
        order.itemDiscounts.updateItemDiscount(item.orderItemUUID)
      }
    }
    updatePriceAndStuff(true)
  }

  function orderClosed(order) {
    if (order.statuses == null) return false
    for (let status of order.statuses.reverse()) {
      if (status.statusID >= OrderStatus.ORDER_CLOSED_SUCCESS) { return status.statusID }
    }
    return 0
  }

  function orderGotStatus(order, statusID) {
    if (order.statuses == null) return false
    for (let status of order.statuses) {
      if (status.statusID === statusID) return true
    }
    return false
  }

  function calculateVatAmounts() {
    let vatAmounts = {}
    for (let item of order.order.items) {
      if(item.discountPrice === 0) continue
      if (vatAmounts[item.vat] == null) vatAmounts[item.vat] = 0
      vatAmounts[item.vat] += +(item.discountPrice || 0)
    }
    return vatAmounts
  }

  function calculateItemDiscountPrice(item) {
    let itemDiscounts = order.order.calculated?.discounts?.items?.[item.orderItemUUID]
    if (itemDiscounts != null && item.count > 0) {
      let discountsTotal = 0
      let packageDiscountsTotal = 0
      for (let discount of Object.values(itemDiscounts.discounts)) {
        discountsTotal += +(discount.amount || 0)
        packageDiscountsTotal += +(discount.packageAmount || 0)
      }
      item.packageDiscountPrice = item.packagePrice - (packageDiscountsTotal / item.count)
      item.sumDiscountPriceUnit = (item.sumPrice - discountsTotal) / item.count
      item.sumDiscountPrice = item.sumPrice - discountsTotal
      item.discountPrice = Math.round(item.totalPrice - discountsTotal - packageDiscountsTotal)
      item.discountPriceUnit = item.discountPrice / item.count
    } else {
      if (item.count > 0) {
        item.packageDiscountPrice = item.packagePrice
        item.sumDiscountPrice = item.sumPrice
        item.sumDiscountPriceUnit = item.sumPriceUnit
        item.discountPrice = item.totalPrice
        item.discountPriceUnit = item.totalPriceUnit
      } else {
        item.packageDiscountPrice = 0
        item.sumDiscountPrice = 0
        item.sumDiscountPriceUnit = 0
        item.discountPrice = 0
        item.discountPriceUnit = 0
      }
    }
    item.discounts = itemDiscounts?.discounts || []
    return item
  }

  function serviceFeeRound(value, rounding) {
    switch (rounding) {
      case 1:
        return Math.round(value)
      case 2:
        return Math.ceil(value)
      default:
        return Math.floor(value)
    }
  }

  function calculateItemServiceFee(item) {
    let serviceFee = order.order.serviceFee || { type: 0, percent: 0, rounding: 0 }
    item.sumDiscountPriceUnitBase = item.sumDiscountPriceUnit
    item.sumPriceUnitBase = item.sumPriceUnit
    if (+serviceFee.type > 0 && item.sumDiscountPrice > 0 && +serviceFee.percent > 0) {
      switch (+serviceFee.type) {
        case 2: {
          let serviceFeeUnit = serviceFeeRound(item.sumDiscountPriceUnit - (item.sumDiscountPriceUnit / (1 + (+serviceFee.percent / 100))), +serviceFee.rounding)
          item.serviceFeeUnit = serviceFeeUnit
          item.serviceFeeUnitNoDiscount = serviceFeeRound(item.sumPriceUnit - (item.sumPriceUnit / (1 + (+serviceFee.percent / 100))), +serviceFee.rounding)
          item.serviceFee = item.count * serviceFeeUnit
          item.serviceFeeNoDiscount = item.count * item.serviceFeeUnitNoDiscount
          // Currect the sumPrices
          item.sumDiscountPrice -= item.serviceFee
          item.sumDiscountPriceUnit -= serviceFeeUnit
          item.sumPrice -= item.serviceFeeNoDiscount
          item.sumPriceUnit -= item.serviceFeeUnitNoDiscount
        }
          break
        case 1:
          item.serviceFeeUnit = serviceFeeRound(item.sumDiscountPriceUnit * (+serviceFee.percent / 100), +serviceFee.rounding)
          item.serviceFee = item.count * item.serviceFeeUnit
          item.serviceFeeUnitNoDiscount = serviceFeeRound(item.sumPriceUnit * (+serviceFee.percent / 100), +serviceFee.rounding)
          item.serviceFeeNoDiscount = item.count * item.serviceFeeUnitNoDiscount
          item.discountPrice += item.serviceFee
          item.discountPriceUnit += item.serviceFeeUnit
          break
        default:
      }
      item.serviceFeeType = serviceFee.type
      item.serviceFeePercent = serviceFee.percent
      item.totalPriceUnit = item.sumPriceUnit + item.packagePrice + +item.depositPrice + (item.serviceFeeNoDiscount / item.count)
      item.totalPrice = item.totalPriceUnit * (item.count || 0)
    } else {
      item.serviceFee = 0
      item.serviceFeeNoDiscount = 0
      item.serviceFeeType = 0
      item.serviceFeePercent = 0
      item.serviceFeeUnit = 0
    }
    return item
  }

  function calculateOrderPrices() {
    order.order.calculated = {
      discounts: order.discounts.calculateDiscounts(order.itemDiscounts.calculateItemDiscounts()),
      serviceFee: {
        type: order?.order?.serviceFee?.type || 0,
        percent: order?.order?.serviceFee?.percent || 0,
        total: 0,
        byVat: {}
      }
    }

    let itemsSumPrice = 0
    let itemsSumDiscountPrice = 0
    let itemsPackagingPrice = 0
    let itemsPackagingDiscountPrice = 0
    let itemsTotalPrice = 0
    let itemsDiscountPrice = 0
    let itemsServiceFee = 0
    let itemsServiceFeeNoDiscount = 0
    let itemsDepositPrice = 0

    for (let item of Object.values(order.assembledOrderItems)) {
      catalog.calculateItemPrices(item, order.order)
      calculateItemDiscountPrice(item)
      calculateItemServiceFee(item)
      if (item.serviceFee > 0) {
        itemsServiceFee += item.serviceFee
        itemsServiceFeeNoDiscount += item.serviceFeeNoDiscount
        order.order.calculated.serviceFee.total += item.serviceFee
        order.order.calculated.serviceFee.byVat[item.vat] = (order.order.calculated.serviceFee.byVat[item.vat] || 0) + item.serviceFee
      }

      itemsPackagingPrice += (item.packagePrice || 0) * (item.count || 0)
      itemsPackagingDiscountPrice += (item.packageDiscountPrice || 0) * (item.count || 0)

      itemsDepositPrice += (item.depositPrice || 0) * (item.count || 0)

      itemsSumPrice += Math.round(item.sumPrice || 0)
      itemsSumDiscountPrice += Math.round(item.sumDiscountPrice || 0)
      itemsTotalPrice += (item.totalPrice || 0)
      itemsDiscountPrice += (item.discountPrice || 0)
    }

    let deliveryCost = order.order.deliveryCost != null ? +order.order.deliveryCost : 0

    order.order.sumServiceFee = itemsServiceFeeNoDiscount
    order.order.sumDiscountServiceFee = itemsServiceFee

    order.order.packagingPrice = itemsPackagingPrice
    order.order.packagingDiscountPrice = itemsPackagingDiscountPrice

    order.order.depositPrice = itemsDepositPrice

    order.order.sumPrice = itemsSumPrice
    order.order.sumDiscountPrice = itemsSumDiscountPrice

    order.order.totalPrice = itemsTotalPrice + (order.order.tipAmount || 0) + deliveryCost
    order.order.discountPrice = itemsDiscountPrice + (order.order.tipAmount || 0) + deliveryCost
    order.order.discountAmount = (order.order.calculated.discounts?.vip?.total || 0) +
      (order.order.calculated.discounts?.coupons?.total || 0) +
      (order.order.calculated.discounts?.local?.total || 0)

    order.order.deliveryPayment = order.externalPayments.calculateDeliveryTotal()

    order.order.paymentsTotal = (+order.payments.calculatePaymentsTotal() + +order.externalPayments.calculateTotal())

    let paymentsNeeded = Math.round(order.order.discountPrice - order.order.paymentsTotal)
    let rounding = Math.abs(paymentsNeeded)
    order.order.paymentsNeeded = rounding <= 2 ? 0 : paymentsNeeded
    order.order.paymentRounding = rounding <= 2 ? paymentsNeeded : 0

    order.order.vatAmounts = calculateVatAmounts()
  }

  function orderPaymentState() {
    let paymentState = { paymentInProgress: false, paymentTypeAllowed: 0, receiptNeeded: 0 }
    if (order.order.payments?.length > 0) {
      paymentState.paymentTypeAllowed = 1
      if (!order.order.invoices?.length && ![1, 2].includes(order.order.orderType)) {
        paymentState.receiptNeeded = 1
      }
    } else {
      if (order.order.externalPayments?.length > 0) {
        paymentState.paymentTypeAllowed = 2
      }
    }
    for (let status of order.order.statuses) {
      if (status.statusID === OrderStatus.ORDER_PAYMENT_STARTED) {
        if (moment(status.notes.expires).isAfter(moment())) {
          let finished = false
          for (let subStatus of order.order.statuses) {
            if (
              subStatus.statusID === OrderStatus.ORDER_PAYMENT_CONFIRMED ||
              subStatus.statusID === OrderStatus.ORDER_PAYMENT_CANCELLED
            ) {
              let payment = order.payments.getPayment('', '', subStatus.notes.uuid)
              if (payment?.paymentID === status.notes?.paymentID) {
                finished = true
              }
            }
          }
          if (!finished) {
            paymentState = { ...paymentState, paymentInProgress: true, ...status.notes }
          }
        }
      }
    }
    return paymentState
  }

  function determineOrderState(order1) {
    let closedStatus = orderClosed(order1)
    if (closedStatus > OrderStatus.ORDER_CLOSED_SUCCESS) { return OrderStates.CLOSED_FAIL }
    if (closedStatus === OrderStatus.ORDER_CLOSED_SUCCESS) { return OrderStates.CLOSED_SUCCESS }
    if (!orderGotStatus(order1, OrderStatus.ORDER_INSERTED)) { return OrderStates.BASKET }
    // Determine order not finalized
    if (order1.paymentsNeeded > 0 && ![1,2].includes(order1.orderType) &&
      ((order1.paymentType !== PaymentType.OFFLINE)
        || (order1.insertDeviceType === 1000
          && order1.paymentType === PaymentType.OFFLINE
          && order1.location?.opr))
    ) {
      let hasFruitRequestStatus = orderGotStatus(order1, OrderStatus.ORDER_FRUITSYS_REQUEST_ORDER)
      if (!hasFruitRequestStatus) return OrderStates.UNCONFIRMED
    }
    // Determine order ready for pickup
    if (orderGotStatus(order1, OrderStatus.ORDER_DONE)) return OrderStates.DONE
    // Determine inserted state
    if (!orderGotStatus(order1, OrderStatus.ORDER_RECEIVED)) { return OrderStates.INSERTED }
    if (order1.requestedReadyTime == null) {
      // Determine seen state
      if ((!orderGotStatus(order1, OrderStatus.ORDER_TIME_ESTIMATE)) && order1?.location?.status?.eta) { return OrderStates.SEEN }
    } else {
      if (moment(order1.requestedReadyTime).isBefore(moment().subtract(30, 'minutes'))) return OrderStates.SCHEDULED
      // If its preparing time, determine seen state
      if ((!orderGotStatus(order1, OrderStatus.ORDER_TIME_ESTIMATE)) && order1?.location?.status?.eta) { return OrderStates.SEEN }
      // // Determine seen state
      // if (((!orderGotStatus(order1, OrderStatus.ORDER_TIME_ESTIMATE)) || (!order1?.location?.status?.eta)) && !orderGotStatus(order1, OrderStatus.ORDER_REMINDER_SET)) { return OrderStates.SEEN }
      // // Determine scheduled state
      // if (orderGotStatus(order1, OrderStatus.ORDER_REMINDER_SET) && !orderGotStatus(order1, OrderStatus.ORDER_REMINDER_ALERT)) { return OrderStates.SCHEDULED }
      // // Determine pending
      // if (!orderGotStatus(order1, OrderStatus.ORDER_TIME_ESTIMATE)) { return OrderStates.PENDING }
    }
    if (!order1?.location?.status?.done) {
      return OrderStates.DONE
    } else {
      return OrderStates.PREPARING
    }
  }

  function setLocationInfo() {
    if (order.order.tableUUID != null) {
      order.order.tableInfo = cloneDeep(catalog?.tables?.[order.order.tableUUID] || null)
    } else {
      order.order.tableInfo = null
    }
    if (order.order?.locationUUID != null) {
      let location = client.locationsModel.getLocation(order.order.locationUUID)
      order.order.location = {
        opr: location?.localConfig?.orders?.online?.paymentRequired || false,
        status: {
          rec: location?.localConfig?.orders?.statuses?.rec || 0, // Order seen
          eta: location?.localConfig?.orders?.statuses?.eta || 0, // ETA for order
          done: location?.localConfig?.orders?.statuses?.done || 0, // Order done
          rbc: location?.localConfig?.orders?.statuses?.rbc || 0 // Received by customer
        },
        serviceFee: location?.localConfig?.serviceFee || null,
        extID: location?.extID,
        name: location?.name,
        extOM: location?.useExternalOrderManager || 0,
        fruitQrPrefix: location?.localConfig?.fruitQrPrefix || null,
      }
    } else {
      order.order.location = null
    }
  }

  function orderCounterStates() {
    let counterStates = {}
    let itemStates = {}
    for (let item of Object.values(order.assembledOrderItems || {})) {
      for (let counter of Object.values(item.prep || {})) {
        counterStates[counter.id] = counterStates[counter.id] || {}
        counterStates[counter.id].total = +(counterStates[counter.id].total || 0) + 1
        counterStates[counter.id][item.state] = +(counterStates[counter.id][item.state] || 0) + 1
      }
      itemStates[item.state] = +(itemStates[item.state] || 0) + 1
    }
    return { itemStates, counterStates }
  }

  function checkForNonScaledItems() {
    let nonScaledItems = false
    for (let item of Object.values(order.assembledOrderItems || {})) {
      if (item?.sizeAttributes?.scale && +item?.quantity === 0) {
        nonScaledItems = true
        break
      }
    }
    return nonScaledItems
  }

  function updatePriceAndStuff(sendUpdate = false) {
    order.order.itemCount = order.items.getCount()
    setLocationInfo()
    order.order.orderState = determineOrderState(order.order)
    let nonBasket = order.order.orderState > 0
    order.order.paymentState = orderPaymentState()
    order.order.nonScaledItems = checkForNonScaledItems()
    calculateOrderPrices()
    let states = orderCounterStates()
    order.order.states = states
    if (sendUpdate) {
      order.callbacks.callCallbacks('onOrderUpdated', order)
    }
    //console.log({ checkCloseOrder: order.checkCloseOrder, orderState: order.order.orderState, 
    //  paymentsNeeded: order.order.paymentsNeeded, rbc: order.order.location?.status?.rbc })
    if (order.checkCloseOrder > 0 && order.order.orderState === OrderStates.DONE) {
      order.checkCloseOrder--
      if ((order.order.paymentsNeeded === 0 || [1,2].includes(order.order.orderType)) && (!order.order.location?.status?.rbc)) {
        // AUTO CLOSE ORDER
        if ((!order.order.paymentState.receiptNeeded) && (!order.order.nonScaledItems)) {
          //console.log('AUTO CLOSE ORDER')
          order.statuses.addStatus(OrderStatus.ORDER_CLOSED_SUCCESS, { auto: true })
          nonBasket = true
        } else {
          order.checkCloseOrder = order.checkCloseOrder ? order.checkCloseOrder + 1 : 1
        }
      }
    }
    if (!nonBasket) order.itemDiscounts.autoApplyItemDiscounts()
  }

  return {
    reBuildAssembledItems
  }
}
